import { render, staticRenderFns } from "./OrderTangjunDetail.vue?vue&type=template&id=628dea76"
import script from "./OrderTangjunDetail.vue?vue&type=script&lang=js"
export * from "./OrderTangjunDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports